import { render, staticRenderFns } from "./AlertBoxDialog.vue?vue&type=template&id=3bff1916&scoped=true&"
import script from "./AlertBoxDialog.vue?vue&type=script&lang=ts&"
export * from "./AlertBoxDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AlertBoxDialog.vue?vue&type=style&index=0&id=3bff1916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff1916",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAvatar,VBtn,VDialog})
